/*
 * <cdx-avis-bundle-visibility> – around the AVIS options in the konfigurator. When a bundle option
 * (.avis-cs-button.avis-bundle-option-product) is clicked, its product's trigger.visibility metafield
 * is looked up via the Storefront API; the popup's info button (.avis-modal-bundle-handle-button) is
 * hidden for "Not Visible Individually" (and when the product can't be read), shown otherwise.
 *   data-storefront-token, data-api-version (theme settings); requests go to the shop's own domain
 */
if (!customElements.get("cdx-avis-bundle-visibility")) {
  const TRIGGER_SELECTOR = ".avis-cs-button.avis-bundle-option-product";
  const HIDE_SELECTOR = ".avis-modal-bundle-handle-button";
  const HIDE_VALUE = "Not Visible Individually";
  const OBSERVE_TIMEOUT = 10000;
  const cache = new Map();

  customElements.define(
    "cdx-avis-bundle-visibility",
    class CdxAvisBundleVisibility extends HTMLElement {
      connectedCallback() {
        this.onClick = (event) => this.handleClick(event);
        // Capture: AVIS may stop the event on its own buttons
        this.addEventListener("click", this.onClick, true);
      }

      disconnectedCallback() {
        this.removeEventListener("click", this.onClick, true);
      }

      async handleClick(event) {
        const button = event.target.closest(TRIGGER_SELECTOR);
        if (!button) return;
        const radio = button.closest("label")?.querySelector('input[type="radio"]');
        const productId = radio?.getAttribute("data-variant-product");
        if (!productId) return;

        const product = await this.getProduct(productId);
        const value = product?.metafield ? product.metafield.value : null;
        const show = !!product && value !== HIDE_VALUE;
        this.whenPopupButtonAppears(() => {
          document.querySelectorAll(HIDE_SELECTOR).forEach((popupButton) => {
            if (show) popupButton.style.removeProperty("display");
            else popupButton.style.setProperty("display", "none", "important");
          });
        });
      }

      getProduct(productId) {
        if (cache.has(productId)) return cache.get(productId);
        const { storefrontToken, apiVersion } = this.dataset;
        const promise = fetch(`/api/${apiVersion}/graphql.json`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Shopify-Storefront-Access-Token": storefrontToken,
          },
          body: JSON.stringify({
            query: `query($id: ID!) {
              product(id: $id) {
                title
                metafield(namespace: "trigger", key: "visibility") { value }
              }
            }`,
            variables: { id: `gid://shopify/Product/${productId}` },
          }),
        })
          .then((response) => response.json())
          .then((json) => (json && json.data ? json.data.product : null))
          .catch(() => null);
        cache.set(productId, promise);
        return promise;
      }

      // The popup is rendered by AVIS after the click (anywhere in the document)
      whenPopupButtonAppears(callback) {
        if (document.querySelector(HIDE_SELECTOR)) {
          callback();
          return;
        }
        const observer = new MutationObserver(() => {
          if (!document.querySelector(HIDE_SELECTOR)) return;
          observer.disconnect();
          callback();
        });
        observer.observe(document.body, { childList: true, subtree: true });
        setTimeout(() => observer.disconnect(), OBSERVE_TIMEOUT);
      }
    }
  );
}
